import { render, staticRenderFns } from "./data-search.vue?vue&type=template&id=6d83a9f1&scoped=true"
import script from "./data-search.vue?vue&type=script&lang=js"
export * from "./data-search.vue?vue&type=script&lang=js"
import style0 from "./data-search.vue?vue&type=style&index=0&id=6d83a9f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d83a9f1",
  null
  
)

export default component.exports